/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import { Segment, Grid, Header, Container, Table, Icon, Button } from 'semantic-ui-react'
import Axios from 'axios'
import APP_CONSTANTS from '../../config/constants'
import HighchartsReact from "highcharts-react-official";
import Chart from 'react-google-charts';

import HistoryModal from './historyModal'
import { Link, useHistory } from 'react-router-dom';

function HomeData() {
    const [data, setdata] = useState([])
    const [monthWise, setmonthWise] = useState([])
    const [jobcards, setjobcards] = useState([])
    const [expryDocs, setexpryDocs] = useState([])
    const [modalOpen, setmodalOpen] = useState(false)
    const [vehicle, setvehicle] = useState([])
    const [vehicleNo, setvehicleNo] = useState([])
    let history = useHistory();


    useEffect(() => {
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let data = JSON.stringify
            ({
                api_token: token,
                customerNo: customerNo,
                userId: userId
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/getDashboard`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": token
            }
        }).then((response => {
            setdata(response.data.data)
            let mainData = response.data.data
            let docCharts = []
            docCharts.push(mainData)
            docCharts.map((object) => {
                setmonthWise(object?.expiredSoonMonthWise)
                setjobcards(object?.jobCardCountTypeWise)
                setexpryDocs(object?.docExpiring15Days)
            })
        }))


    }, [])

    let monthArray = []
    let exDateArray = []
    if (monthWise !== null && monthWise !== 'undefined' && monthWise?.length > 0) {
        monthWise.map((o) => {
            monthArray.push(o.expiryMonthYear)
            exDateArray.push(o.expiredsoondocs)
        })
    }

    let jobCardType = []
    let jobCardCount = []
    jobcards && jobcards.map((o) => {
        jobCardType.push(o.jobCardType)
        jobCardCount.push(o.jobCardCount)
    })


    let DashboardInfo = []
    DashboardInfo.push(data)
    const options1 = {
        credits: {
            enabled: false
        },
        chart: {
            type: 'column'
        },
        title: {
            text: 'No. Of Documents Expiring'
        },
        colors: ['orange'],
        xAxis: {
            categories: monthArray
        },
        yAxis: {
            allowDecimals: false,
            min: 0,
            title: {
                text: 'No. of Documents Expiring'
            }
        },

        tooltip: {
            formatter: function () {
                return '<b>' + this.x + '</b><br/>' +
                    this.series.name + ': ' + this.y + '<br/>';
            }
        },

        plotOptions: {
            column: {
                stacking: 'normal'
            },
            candlestick: {
                lineColor: '#404048'
            },
        },

        series: [{
            name: 'Expiring Month',
            data: exDateArray,
            stack: ''
        }]
    }

    const options =
        [
            ['Jobcard', 'Per Month'],
            [jobCardType[0], jobCardCount[0]],
            [jobCardType[1], jobCardCount[1]],
            [jobCardType[2], jobCardCount[2]],
            [jobCardType[3], jobCardCount[3]],
            [jobCardType[4], jobCardCount[4]],
        ]


    const handleHistoryModal = (id, vehicleNo) => {
        setvehicle(id)
        setvehicleNo(vehicleNo)
        setmodalOpen(true)
    }

    const handleHistoryCloseModal = (e) => {
        window.location.reload()
        setmodalOpen(false)

    }

    return (
        <>
            <div id="dispatch_bar" className="pad">
                {DashboardInfo.map((object, index) => (
                    <Grid columns="equal" key={index}>
                        <Grid.Row>
                            <Grid.Column>
                                <Segment className="gblue height-115 cardCursor"
                                    onClick={(e) => {
                                        history.push({
                                            pathname: '/vehicle',
                                            state: {
                                                tags: 'your-value'
                                            }
                                        })
                                            ; window.location.href = '/vehicle'
                                    }}>

                                    <Header as="p" size="small" className="p-bold-500 w3-text-white height-45">Total Vehicles</Header>
                                    <Header as="p" size="huge" className="p-bold-600 w3-text-white">{object?.vehicleCount}</Header>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column>
                                <Segment className="gred height-115 cardCursor" onClick={(e) => {
                                    history.push({
                                        pathname: '/document',
                                        state: {
                                            tags: 'Expired Documents',
                                            ExpiryType: 2
                                        }
                                    });
                                    window.location.href = '/document'
                                }}>
                                    <Header as="p" size="small" className="p-bold-500 w3-text-white height-45">Expired Document</Header>
                                    <Header as="p" size="huge" className="p-bold-600 w3-text-white">{object?.docExpiredCount}</Header>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column>
                                <Segment className="gorang height-115 cardCursor" onClick={(e) => {
                                    history.push({
                                        pathname: '/document',
                                        state: {
                                            tags: 'Documents expiring soon',
                                            ExpiryType: 3
                                        }
                                    });
                                    window.location.href = '/document'
                                }}>
                                    <Header as="p" size="small" className="p-bold-500 w3-text-white height-45">Document Expiring Soon</Header>
                                    <Header as="p" size="huge" className="p-bold-600 w3-text-white">{object?.docExpiredSoonCount}</Header>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column>
                                <Segment className="glgreen height-115 cardCursor" onClick={(e) => {
                                    history.push({
                                        pathname: '/jobcard',
                                        state: {
                                            tags: 'Current month jobcard'
                                        }
                                    });
                                    window.location.href = '/jobcard'
                                }}>
                                    <Header as="p" size="small" className="p-bold-500 w3-text-white height-45">Current Month Jobcard</Header>
                                    <Header as="p" size="huge" className="p-bold-600 w3-text-white">{object?.currentMonthJobCardCount}</Header>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column>
                                <Segment className="gpurple height-115 cardCursor" onClick={(e) => { window.location.href = '/approvals' }}>
                                    <Header as="p" size="small" className="p-bold-500 w3-text-white height-45">Pending Approvals</Header>
                                    <Header as="p" size="huge" className="p-bold-600 w3-text-white">{object?.pendingJobCardApprovalCount}</Header>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                ))}
            </div>

            <Container >
                <Grid columns="equal">
                    <Grid.Row>
                        <Grid.Column className="ml-2">
                            {monthArray.length > 0 ?
                                <Segment color="blue">
                                    <HighchartsReact
                                        options={options1}
                                    />
                                </Segment>
                                :
                                <Segment color="blue">
                                    <Header as='h3' size="tiny" textAlign="center">
                                        No. Of Documents Expiring
                                    </Header>
                                </Segment>
                            }
                        </Grid.Column>
                        <Grid.Column>
                            <Segment color="blue" className={expryDocs && expryDocs.length > 0 ? 'dashboardTable' : ''}>
                                <Header as="center" size="tiny"> Documents Expiring in 15 Days</Header>
                                {expryDocs && expryDocs.length > 0 ?
                                    <>
                                        <Table size="small" className="w3-small">
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell className="p-bold-500" >Vehicle No.</Table.HeaderCell>
                                                    <Table.HeaderCell className="p-bold-500">Document Type</Table.HeaderCell>
                                                    <Table.HeaderCell className="p-bold-500">End Date</Table.HeaderCell>
                                                    <Table.HeaderCell className="p-bold-500">Days Left</Table.HeaderCell>
                                                    {/* <Table.HeaderCell>History</Table.HeaderCell>
                                                        <Table.HeaderCell>Upload</Table.HeaderCell> */}
                                                    <Table.HeaderCell className='p-bold-500'>History</Table.HeaderCell>
                                                    <Table.HeaderCell className="p-bold-500">Download</Table.HeaderCell>
                                                    <Table.HeaderCell className='p-bold-500'>Edit</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {expryDocs.map((object, index) => (
                                                    <>
                                                        <Table.Row key={index + 1}>
                                                            <Table.Cell>{object.vehicleNo}</Table.Cell>
                                                            <Table.Cell>{object.docTypeName}</Table.Cell>
                                                            <Table.Cell>{object.expiryDate}</Table.Cell>
                                                            <Table.Cell>{object.diffDays ? `${object.diffDays} Days` : ''}</Table.Cell>
                                                            <Table.Cell>
                                                                <Button onClick={() => handleHistoryModal(object.vehicleId, object.vehicleNo)} size="mini" basic color="blue" icon>
                                                                    <Icon name='history' />
                                                                </Button>
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                <Button disabled={object.documentLink ? false : true} onClick={() => window.open(object.documentLink, "_blank")} size="mini" basic color="yellow" icon>
                                                                    <Icon name='download' />
                                                                </Button>
                                                            </Table.Cell>
                                                            <Table.Cell>
                                                                <Link to={{ pathname: "/edit-document/" + object.vehicleId }} >
                                                                    <Button size="mini" basic color="green" icon="edit" />
                                                                </Link>
                                                            </Table.Cell>
                                                        </Table.Row>
                                                    </>
                                                ))}
                                            </Table.Body>
                                        </Table>
                                    </>
                                    :
                                    ''}

                            </Segment>
                            {vehicle > 0 ? <HistoryModal modalOpen={modalOpen} handleClose={handleHistoryCloseModal} vehicle={vehicle} vehicleNo={vehicleNo} /> : null}

                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column className="ml-2" width={8}>
                            <Segment color="blue">
                                <Header as="center" size="tiny"> Current Month Jobcard</Header>
                                <Chart
                                    chartEvents={[
                                        {
                                            eventName: "ready",
                                            callback: ({ chartWrapper, google }) => {
                                                const chart = chartWrapper.getChart();
                                                google.visualization.events.addListener(chart, "click", e => {
                                                    if (e.targetID === "slice#0") {
                                                        history.push({
                                                            pathname: '/jobcard',
                                                            state: {
                                                                tags: 'Battery',
                                                                jobCardTypeId: 3
                                                            }
                                                        }); window.location.href = '/jobcard'
                                                    }
                                                    else if (e.targetID === "slice#1") {
                                                        history.push({
                                                            pathname: '/jobcard',
                                                            state: {
                                                                tags: 'Tyre',
                                                                jobCardTypeId: 2
                                                            }
                                                        });
                                                        window.location.href = '/jobcard'
                                                    }
                                                    else if (e.targetID === "slice#2") {
                                                        history.push({
                                                            pathname: '/jobcard',
                                                            state: {
                                                                tags: 'Fuel',
                                                                jobCardTypeId: 4
                                                            }
                                                        });
                                                        window.location.href = '/jobcard'
                                                    }
                                                    else if (e.targetID === "slice#3") {
                                                        history.push({
                                                            pathname: '/jobcard',
                                                            state: {
                                                                tags: 'Repair',
                                                                jobCardTypeId: 5
                                                            }
                                                        });
                                                        window.location.href = '/jobcard'
                                                    }
                                                    else if (e.targetID === "slice#4") {
                                                        history.push({
                                                            pathname: '/jobcard',
                                                            state: {
                                                                tags: 'test',
                                                                jobCardTypeId: 6
                                                            }
                                                        });
                                                        window.location.href = '/jobcard'
                                                    }
                                                });
                                            }
                                        }
                                    ]}
                                    width={'500px'}
                                    height={'300px'}
                                    chartType="PieChart"
                                    loader={<div>Loading...</div>}
                                    data={options}
                                    options={{
                                        pieHole: 0.4,
                                        slices: {
                                            0: { color: '#4BAD44' },
                                            1: { color: '#FCDC2A' },
                                            2: { color: '#24A5DD' },
                                            3: { color: '#DA1719' },
                                            4: { color: '#F78730' },
                                        },
                                        pieSliceText: 'value',
                                        tooltip: {
                                            text: 'value'
                                        }

                                    }}
                                    rootProps={{ 'data-id': '2' }}
                                />
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </>
    )
}

export default HomeData
